import Cookies from 'js-cookie';
import ConfigJSON from '../../../config.json';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling

export default function () {
    jQuery(document).ready(function ($) {

        let token = '';
        let tippyTemplate = $('#tippy-template').html();

        if (tippyTemplate) {
            let tippyParam = {
                content: tippyTemplate,
                allowHTML: true,
                placement: 'right',
                trigger: 'focus',
                theme: 'recpass',
            };

            if (window.innerWidth < ConfigJSON.desktopBreakWidth) {
                tippyParam.placement = 'top-end';
            }

            let resTippy = tippy('.myusa-change-pass-form input[name="pass"], .myusa-change-pass-form input[name="reppass"]', tippyParam);

            $(window).on('resize', function () {
                if (window.innerWidth < ConfigJSON.desktopBreakWidth) {
                    resTippy.forEach(function (inst) {
                        inst.setProps({ placement: 'top-end' })
                    });
                } else {
                    resTippy.forEach(function (inst) {
                        inst.setProps({ placement: 'right' })
                    });
                }
            });
        }

        if ($('.myusa-change-pass-form input[name="email"]').val() && $('.myusa-change-pass-form input[name="token"]').val()) {
            console.log('Get auth token from restore token');

            let email = $(this).find('.myusa-change-pass-form input[name="email"]');
            let recToken = $(this).find('.myusa-change-pass-form input[name="token"]')

            $.ajax({
                url: LK.api_domain + '/auth',
                method: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                data: JSON.stringify({
                    email: email.val().trim(),
                    token: recToken.val().trim(),
                }),
                complete: function (jqXHR, status) {
                    if (jqXHR.status == 200) { // if we login success and have tokin
                        console.log("🚀 ~ file: restore-password.js:27 ~ jqXHR:", jqXHR)

                        token = jqXHR.getResponseHeader('Authorization');
                        Cookies.set('lk-bearer', token, { expires: 2 });

                        $.ajax({
                            url: LK.api_domain + '/api/v1/me',
                            method: 'GET',
                            xhrFields: {
                                withCredentials: true
                            },
                            headers: {
                                'Authorization': token,
                            },
                            async: false,
                            contentType: 'application/json',
                            complete: function (jqXHR, status) {
                                let me = jqXHR.responseJSON;
                                if (jqXHR.status != 200) {
                                    window.location = '/my-account';
                                }

                                console.log("/api/v1/me:", me);

                                // update user info
                                $('.myusa-change-pass-form').attr('data-client-id', me.data.id);
                                $('.myusa-change-pass-form').attr('data-client-email', me.data.attributes.email);
                                $('.myusa-change-pass-form').attr('data-client-name', me.data.attributes.name);
                            }
                        });

                    } else { // if somthing wrong
                        window.location = '/my-account/restore-password';
                    }
                }
            });
        }

        $('.myusa-change-pass-form').on('submit', function (e) {
            e.preventDefault();

            let passInput = $('.myusa-change-pass-form input[name="pass"]');
            let reppassInput = $('.myusa-change-pass-form input[name="reppass"]');
            let passRegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z!#@%$&*\d]{8,}$/;

            passInput.removeClass('error');
            reppassInput.removeClass('error');
            $('.input_error').hide();

            if (!passRegEx.test(passInput.val())) {
                passInput.addClass('error');
                return;
            }

            if (passInput.val() != reppassInput.val()) {
                reppassInput.addClass('error');
                reppassInput.next('.input_error').show();
                return;
            }
            passInput.removeClass('error');
            reppassInput.removeClass('error');

            let pass = passInput.val();

            let data = {
                attributes: {
                    name: $('.myusa-change-pass-form').attr('data-client-name'),
                    email: $('.myusa-change-pass-form').attr('data-client-email'),
                    password: pass,
                },
                id: $('.myusa-change-pass-form').attr('data-client-id'),
                type: 'clients',
            };


            $.ajax({
                url: LK.api_domain + '/api/v1/me',
                method: 'PATCH',
                xhrFields: {
                    withCredentials: true
                },
                headers: {
                    'Authorization': token,
                },
                data:
                    JSON.stringify({
                        data
                    }),
                async: false,
                contentType: 'application/json',
                complete: function (jqXHR, status) {

                    let resMe = jqXHR.responseJSON;
                    console.log("PATCH /api/v1/me", resMe);

                    if (jqXHR.status == 200) {
                        window.location = '/lk/orders';
                    } else {

                        window.location = '/my-account/restore-password';
                    }
                }
            });

        });

        $('.myusa-restore-form').on('submit', function (e) {
            e.preventDefault();

            let email = $(this).find('input[name="email"]');

            if (!email.val().trim()) {
                return;
            }

            email.hide();
            $(this).find('h3.no-problem').hide();
            $(this).find('button').hide();
            $(this).find('.restore-info').show();

            $.ajax({
                url: LK.api_domain + '/auth/reset-password',
                method: 'POST',
                //contentType: 'application/json',
                //dataType: 'json',
                data: {
                    email: email.val().trim(),
                },
                complete: function (jqXHR, status) {
                    if (jqXHR.status == 200) { // if we login success and have tokin
                        console.log("🚀 ~ file: restore-password.js:25 ~ jqXHR:", jqXHR)

                    } else { // if somthing wrong

                    }
                }
            });
        });
    });
};